import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { SvgIconComponent } from 'angular-svg-icon';
import { Observable } from 'rxjs';
import { CampaignContentState } from '../../store/models/campaign-models';
import { selectCampaignContentByKey } from '../../store/selectors/campaign.selectors';
import { ContentComponent } from '../common/content/content.component';
import { FormPageComponent } from '../common/form/form.component';
import { PageComponent } from '../common/page/page.component';

@Component({
    selector: 'registration-completed',
    templateUrl: './registration-completed.component.html',
    styleUrl: './registration-completed.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SvgIconComponent, PageComponent, FormPageComponent, AsyncPipe, ContentComponent]
})
export class RegistrationCompletedComponent {
  protected pageHeadingKey: string = 'registration-completed-page-heading';
  protected pageHeadingValue$: Observable<string | null>;
  protected pageBodyKey: string = 'registration-completed-page-body';
  protected pageBodyValue$: Observable<string | null>;

  constructor(private contentStore: Store<CampaignContentState>) {
    this.pageHeadingValue$ = this.contentStore.select(selectCampaignContentByKey(this.pageHeadingKey));
    this.pageBodyValue$ = this.contentStore.select(selectCampaignContentByKey(this.pageBodyKey));
  }
}
